export default {
  'load_generators.label.singular': 'Load Generator',
  'load_generators.label.plural': 'Load Generators'
}
